import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { userRoles } from "../../contexts/AuthProvider";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const ManageUser = Loadable(
  lazy(() =>
    import("./UsersList/ManageUser").then(({ ManageUser }) => ({
      default: ManageUser,
    })),
  ),
);

const ViewProfile = Loadable(
  lazy(() =>
    import("./ViewProfile/ViewProfile").then(({ ViewProfile }) => ({
      default: ViewProfile,
    })),
  ),
);

const UserBranch = Loadable(
  lazy(() =>
    import("../Profile/userBranch/UserBranchList").then(({ BranchList }) => ({
      default: BranchList,
    })),
  ),
);

const ManageUserBranch = Loadable(
  lazy(() =>
    import("../Profile/userBranch/ManageUserBranch").then(
      ({ ManageUserBranch }) => ({
        default: ManageUserBranch,
      }),
    ),
  ),
);

const UserList = Loadable(
  lazy(() =>
    import("../Profile/UsersList/UsersList").then(({ UserList }) => ({
      default: UserList,
    })),
  ),
);

export const profileRoutes = [
  {
    path: "/view-profile",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
        <ViewProfile />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/users/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
        <ManageUser />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/users",
    exact: true,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.USERS]}
        // allowedRoles={[
        //   userRoles.ADMIN,
        //   userRoles.ENR_ADMIN,
        //   userRoles.OWNER,
        //   userRoles.WHATSAPPADMIN,
        // ]}
      >
        <UserList key="users" />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.EnrUsers,
    exact: true,
    element: (
      <AuthorizedRoute
        allowedRoles={[userRoles.ENR_ADMIN]}
        moduleIds={[ALLOWED_MODULES.USERS_ENR]}
      >
        <UserList  key="enr-users" module={"ENR"} />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/enr-users/manage/:userId",
    exact: true,
    element: (
      <AuthorizedRoute
        allowedRoles={[userRoles.ENR_ADMIN]}
        moduleIds={[ALLOWED_MODULES.USERS_ENR]}
      >
        <ManageUser module={"ENR"} />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/users/manage/:userId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
        <ManageUser />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/my-profile",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
        <ManageUser />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/user-branch",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.USER_BRANCH]}>
        <UserBranch />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/user-branch/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.USER_BRANCH]}>
        <ManageUserBranch />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/user-branch/manage/:branchUUId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.USER_BRANCH]}>
        <ManageUserBranch />
      </AuthorizedRoute>
    ),
  },
];
